import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-table' })
export class TableComponent {
	constructor(public element: HTMLElement) {
        var elements = element.querySelectorAll('.js-table-header-element');
        var highestElement = 0;

        elements.forEach(el => {
            var height = el?.querySelector('p')?.getBoundingClientRect().height;

            if(height && highestElement < height) {
                highestElement = height;
            }
        });
        elements.forEach(el => {
            el.setAttribute("style", `height: ${highestElement / 10 + 2}rem`) 
        });
	};
}